export * from './TabPanel';
export { default } from './TabPanel';
